import { getInstance } from '../../../scripts/lib/views';

const name = 'field-country';

export default class FormCountry {

  constructor ($el) {
    this.$el = $el;
    this.classname = 'field-country';
    this.$countrySelect = $el.querySelector(`.${name}__country select`);
    this.$stateSelectDE = $el.querySelector(`.${name}__state-de`);
    this.$stateSelectAT = $el.querySelector(`.${name}__state-at`);
    this.$stateSelectCH = $el.querySelector(`.${name}__state-ch`);

    // Create a map for the state selects
    this.stateSelects = {
      de: {
        field: this.$stateSelectDE,
        instance: getInstance(this.$stateSelectDE)
      },
      at: {
        field: this.$stateSelectAT,
        instance: getInstance(this.$stateSelectAT)
      },
      ch: {
        field: this.$stateSelectCH,
        instance: getInstance(this.$stateSelectCH)
      }
    };

    // Bind the change event for the country list and fire the initial event
    this.$countrySelect.onchange = this.onCountryChange.bind(this);
    this.onCountryChange();
  }

  onCountryChange () {
    const value = this.$countrySelect.value;

    // Hide and disable all selects
    for (let selectIndex in this.stateSelects) {
      const select = this.stateSelects[selectIndex];

      if (select.instance !== null && select.field !== null) {
        select.instance.isHidden = true;
        select.field.classList.add('form-field--hidden');
      }
    }

    // Enable the corresponding state select
    switch (value) {
      case 'Deutschland':
        if (this.stateSelects.de.instance !== null
          && this.$stateSelectDE.classList !== null) {
          this.stateSelects.de.instance.isHidden = false;
          this.$stateSelectDE.classList.remove('form-field--hidden');
        }
        break;
      case 'Österreich':
        if (this.stateSelects.at.instance !== null
          && this.$stateSelectAT.classList !== null) {
          this.stateSelects.at.instance.isHidden = false;
          this.$stateSelectAT.classList.remove('form-field--hidden');
        }
        break;
      case 'Schweiz':
        if (this.stateSelects.ch.instance !== null
          && this.$stateSelectCH.classList !== null) {
          this.stateSelects.ch.instance.isHidden = false;
          this.$stateSelectCH.classList.remove('form-field--hidden');
        }
        break;
    }
  }
}
